var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.4044 7.29413L16.6643 4.5442C16.3067 4.20708 15.8381 4.01365 15.3477 4.0007C14.8572 3.98774 14.3791 4.15617 14.0043 4.47395L5.00421 13.5065C4.68098 13.8337 4.47971 14.2625 4.43421 14.7209L4.0042 18.906C3.99073 19.053 4.00974 19.2012 4.05986 19.34C4.10999 19.4788 4.19001 19.6047 4.29421 19.7089C4.38765 19.802 4.49846 19.8755 4.6203 19.9255C4.74214 19.9754 4.87261 20.0007 5.00421 20H5.09422L9.26426 19.6186C9.72106 19.5729 10.1483 19.3709 10.4743 19.0465L19.4744 10.0139C19.8237 9.64358 20.0125 9.14933 19.9994 8.63952C19.9862 8.12971 19.7723 7.64591 19.4044 7.29413ZM9.08426 17.6114L6.08423 17.8924L6.35423 14.8815L12.0043 9.2813L14.7043 11.9911L9.08426 17.6114ZM16.0043 10.6462L13.3243 7.95652L15.2743 5.94928L18.0044 8.68916L16.0043 10.6462Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.13bbb212c01f94bebcba51757efc34b2.svg";
export { ForwardRef as ReactComponent };